<template>
  <v-container grid-list-xl>
    <v-layout
      wrap
      justify-space-between
      v-if="!checking"
    >
      <v-flex
        xs12
        md12
      >
          <h1>이메일 등록</h1>
          <h1>Email Registration</h1>
      </v-flex>
      
      <v-flex
        xs12
        md12
      >
        <v-form ref="email_form" @submit="check"           onSubmit="return false;">
          <v-text-field
            v-model="email"
            :rules="[rules.email]"
            :error-messages="email_error_messages"
            :disabled="checking"
            @input="email_error_messages = []"
            label="이메일 Email"
          ></v-text-field>
          <v-alert
              :value="broken_domain"
              type="warning"
            >
              Your email domain is known have trouble receiving emails.  We recommend using a different email if you have one.
              <br/>해당 이메일 도메인은 제대로 동작하지 않거나 메일이 전달되는데 많은 시간이 소요되는 경우가 있습니다.
            </v-alert>
          <v-btn @click="check" :disabled="checking">인증 메일 받기 / Check Email</v-btn>
        </v-form>
      </v-flex>
    </v-layout>


    <v-layout wrap justify-space-between v-if="checking">
	<h1>Check Email sent to: {{ email }}</h1>

      <v-flex
        xs12
        md12
      >
        <v-form ref="confirm_form" @submit="confirm"           onSubmit="return false;">
          <v-text-field
            v-model="confirmation"
            :counter="6"
            :rules="[rules.confirmation_numbers]"
            :error-messages="confirmation_error_messages"
            label="인증번호 입력하세요 Confirmation #"
          ></v-text-field>
        </v-form>
      </v-flex>
      <v-btn color="primary" @click="confirm"> Confirm</v-btn>
      <v-btn @click="uncheck">전화번호 수정하기 / Change Email</v-btn>
      </div>
    </v-layout>

    <v-layout wrap>
      <v-flex
        xs12
        md12
        text-xs-left
      >
        <h3>Why do I need to do this?</h3>
        <h3>왜 이메일을 등록해야하나요?</h3>
        We need to know we can contact you for announcments/updates.
        <br/>주최측에서 당신에게 주요 공지사항을 전달하기 위해 필요합니다. 


        <ul>
        <li>도메인과 상관없이 개인의 메일 설정(스팸 설정 및 스팸필터 레벨)으로 인해 메일이 받아지지 않을 수 있습니다. </li>
        <li>Be sure to check your spam folder</li>
        <li>주최측의 이메일이 스팸 폴더로 가지 않는지 체크해주세요.</li>
        <li>If you can't get the confirmation email, use another email addess from a different company</li>
        <li>인증 메일을 받지 못했다면 다른 회사에서 제공하는 이메일로 등록을 진행해주시기 바랍니다.</li>
        </ul>
        <br/>
        Domains that usually don't work well
        <br/>다음 도메인들의 메일은 제대로 동작하지 않거나 메일이 전달되는 데 많은 시간이 소요되는 경우가 있습니다.
        <ul>
            <li>hanmail.net</li>
            <li>nate.com</li>
            <li>School/College emails</li>
            <li>학교에서 제공하는 이메일</li>
            <li>*@*.ac.kr</li>
            <li>*@*.edu</li>
        </ul>
        <br/>
        Domains that usually work well
        <br/>다음 도메인들의 메일들은 일반적으로 잘 동작합니다. 
        <ul>
            <li>gmail.com</li>
            <li>naver.com</li>
            <li>G-Suite or Google Apps (Gmail에서 제공하는 회사 혹은 기관 이메일)</li>
        </ul>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import {fetcher} from '@/fetcher.js';
export default {
  props: ['auth'],
  data: () => ({
    email: '',
    email_error_messages: [],
    checking: false,
    broken_domain: false,
    confirmation: '',
    confirmation_disabled: true,
    confirmation_error_messages: [],
    checking: false,
    finished: false,
    rules: {
      required: value => !!value || 'Required.',
      counter: value => value.length <= 20 || 'Max 20 characters',
      confirmation_numbers: value => {
        const pattern = /^\d{6}$/;
        return pattern.test(value) || 'Should only 6 digits';
      },
      email: value => {
        const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return pattern.test(value) || 'Invalid e-mail.';
      },
    },
  }),
  watch: {
    email(to) {
      if (to.match(/.*@hotmail/)) {
        this.broken_domain = true;
      } else if (to.match(/.*@hanmail/)) {
        this.broken_domain = true;
      } else if (to.match(/.*@nate/)) {
        this.broken_domain = true;
      } else if (to.match(/.*@.*lycos/)) {
        this.broken_domain = true;
      } else if (to.match(/.*@.*ac\.kr/)) {
        this.broken_domain = true;
      } else if (to.match(/.*@.*\.edu/)) {
        this.broken_domain = true;
      } else {
        this.broken_domain = false;
      }
    },
  },
  methods: {
    check: async function({router}) {
      if (this.$refs.email_form.validate()) {
        try {
          var res = await fetcher.post('/authemail/check', {email: this.email});
          if (!res.data.success) {
            this.email_error_messages = res.data.message;
            console.log(
              'fail email',
              this.email_error_messages,
              res.data.message,
            );
          } else {
            this.checking = true;
          }
        } catch {}
      }
    },
    uncheck() {
      this.checking = false;
    },
    confirm: async function() {
      if (!this.$refs.confirm_form.validate()) {
        this.confirmation_error_messages = 'Incorrect Number';
        return false;
      }

      var res = await fetcher.post('/authemail/verify', {
        email: this.email,
        code: this.confirmation,
      });
      console.log('verify result', res);

      if (!res.data.success) {
        this.confirmation_error_messages =
          'Invalid Confirmation Code.  Please check the NEWEST message and try again';
        console.log(
          'fail confirmation',
          this.confirmation_error_messages,
          res.data.message,
        );
      } else {
        this.finished = true;
        let cancelHandle = this.$scrollTo('#appbody'); // scroll to top of page
        await this.$store.dispatch('loadProfile');
        this.$router.push('/');
        return;
      }
    },
  },
};
</script>
